export interface RequestInitWithTimeout extends RequestInit {
  // Timeout
  timeout?: number;
}

// fetchWithCredentials is a wrapper around fetch that includes credentials and supports timeout.
// It by default includes credentials: 'include' in the request options.
// This is useful for making requests that require cookies (such as auth_token) to be sent.
export const fetchWithCredentials = async (
  input: string | URL | Request,
  options: RequestInitWithTimeout = {}
): Promise<Response> => {
  const { timeout, ...restOptions } = options;

  // If timeout is provided and greater than 0, use abort controller
  if (timeout && timeout > 0) {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
      const response = await fetch(input, {
        ...restOptions,
        credentials: "include",
        signal: controller.signal,
      });
      clearTimeout(id);
      return response;
    } catch (error) {
      clearTimeout(id);
      throw error;
    }
  }

  // If no timeout, work like regular fetch but with credentials
  return fetch(input, {
    ...restOptions,
    credentials: "include",
  });
};
